import React from 'react';
import { Link } from 'react-router-dom';
import { getPlantImage } from '../data/plantEmojis';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const imgSrc   = product.imageUrl || getPlantImage(product.image);
  const discount = product.originalPrice
    ? Math.round((1 - product.price / product.originalPrice) * 100)
    : null;
  const tags = product.tags || [];
  const isOutOfStock = product.inStock === false;

  // Every card links to /product/:slug. If somehow slug is missing, fall back
  // to a hash so the card still renders without throwing.
  const href = product.slug ? `/product/${product.slug}` : '#';

  return (
    <article className="pc">
      <Link to={href} className="pc__link" aria-label={`View ${product.name}`}>
        {/* Image */}
        <div className="pc__img-wrap">
          <img src={imgSrc} alt={product.name} className="pc__img" loading="lazy" />
          {product.badge && !isOutOfStock && <span className="pc__badge">{product.badge}</span>}
          {discount && !isOutOfStock && <span className="pc__discount">−{discount}%</span>}
          {isOutOfStock && <span className="pc__oos-badge">Out of Stock</span>}
        </div>

        {/* Info */}
        <div className="pc__info">
          {/* Stars */}
          <div className="pc__stars">
            {product.reviews > 0 ? (
              <>
                {[1,2,3,4,5].map(i => (
                  <svg key={i} width="13" height="13" viewBox="0 0 24 24"
                    fill={i <= Math.round(product.rating) ? '#F59E0B' : 'none'}
                    stroke="#F59E0B" strokeWidth="1.5">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                ))}
                <span className="pc__rating-val">{Number(product.rating).toFixed(1)}</span>
                <span className="pc__rating-cnt">| {product.reviews} review{product.reviews !== 1 ? 's' : ''}</span>
              </>
            ) : (
              <span className="pc__rating-empty">No reviews yet</span>
            )}
          </div>

          <h3 className="pc__name">{product.name}</h3>

          {/* Tags — each tag may carry custom colours and an optional icon/gif */}
          {tags.length > 0 && (
            <div className="pc__tags">
              {tags.map((t, i) => {
                // Support both legacy string tags and rich tag objects
                const label      = typeof t === 'string' ? t : (t.label || '');
                const color      = typeof t === 'object' && t.color      ? t.color      : '#2d6a4f';
                const bgColor    = typeof t === 'object' && t.bgColor    ? t.bgColor    : '#f0f7f2';
                const borderColor= typeof t === 'object' && t.borderColor? t.borderColor: '#c6e0ce';
                const iconUrl    = typeof t === 'object' ? (t.iconUrl || '') : '';
                return (
                  <span
                    key={i}
                    className="pc__tag"
                    style={{ color, background: bgColor, borderColor }}
                  >
                    {iconUrl && (
                      <img
                        src={iconUrl}
                        alt=""
                        className="pc__tag-icon"
                        aria-hidden="true"
                      />
                    )}
                    {label}
                  </span>
                );
              })}
            </div>
          )}

          {/* Price */}
          <div className="pc__price-row">
            <span className="pc__price-now">₹{product.price.toLocaleString()}</span>
            {product.originalPrice && (
              <span className="pc__price-was">₹{product.originalPrice.toLocaleString()}</span>
            )}
          </div>

          <span className="pc__view">View Product</span>
        </div>
      </Link>
    </article>
  );
}